import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const data = {
  title: 'Meta',
  subtitle: 'Ads (Facebook & Instagram)',
  tagline: 'Social Advertising That Converts',
  icon: '',
  // icon: '📊',

  heroDesc: 'Leverage the world\'s most powerful social advertising platform to reach your ideal customers on Facebook and Instagram with laser-targeted campaigns that deliver real results.',
  mainStat: '5x',
  mainStatLabel: 'Average ROAS for our Meta Ads clients',
  subStats: [{ value: '200+', label: 'Campaigns Managed' }, { value: '35%', label: 'Avg Cost Reduction' }],
  features: [
    { icon: '👥', title: 'Audience Targeting', desc: 'Pinpoint your ideal customer using demographics, interests, behaviors, and custom audiences.' },
    { icon: '🎨', title: 'Creative Ad Design', desc: 'Scroll-stopping image and video ads crafted by our creative team.' },
    { icon: '🔄', title: 'Retargeting Campaigns', desc: 'Re-engage warm audiences who visited your website or interacted with your page.' },
    { icon: '📈', title: 'Lead Generation Ads', desc: 'Capture leads directly within Facebook without users leaving the platform.' },
    { icon: '🛒', title: 'Catalogue & Shopping Ads', desc: 'Dynamic product ads that show the right products to the right people.' },
    { icon: '📊', title: 'Pixel Implementation', desc: 'Full Facebook Pixel setup for accurate conversion tracking and retargeting.' },
  ],
  benefits: [
    { title: 'Massive Audience Reach', desc: 'Access over 2 billion active users across Facebook and Instagram.' },
    { title: 'Precise Targeting', desc: 'Target by age, location, interests, behaviors, and lookalike audiences.' },
    { title: 'Cost-Effective Leads', desc: 'Generate high-quality leads at a significantly lower cost than traditional advertising.' },
    { title: 'Brand Awareness at Scale', desc: 'Build massive brand recognition among your target demographic quickly.' },
  ],
  process: [
    { title: 'Strategy & Research', desc: 'Define campaign objectives, target audiences, and creative direction.' },
    { title: 'Pixel & Account Setup', desc: 'Meta Pixel, events, and conversion tracking fully configured.' },
    { title: 'Creative Production', desc: 'High-converting ad creatives — images, carousels, and videos.' },
    { title: 'Campaign Launch', desc: 'Campaigns structured for maximum learning phase efficiency.' },
    { title: 'Scale & Optimize', desc: 'Winning ad sets scaled, underperformers paused, budgets reallocated.' },
  ],
  whyChoose: [
    { icon: '🎯', title: 'Audience Expertise', desc: 'Deep knowledge of Meta\'s targeting options to find your perfect customer.' },
    { icon: '✍️', title: 'Creative That Converts', desc: 'Ad creatives designed to stop the scroll and drive action.' },
    { icon: '📊', title: 'Weekly Optimization', desc: 'Regular review cycles to keep campaigns performing at their peak.' },
    { icon: '🔒', title: 'Full Transparency', desc: 'You always have access to your ad account. No black boxes.' },
  ],
  reviews: [
    { name: 'Vijay Khanna', role: 'Education Platform', text: 'Our cost per lead dropped from ₹800 to ₹150 after DMS took over our Meta Ads. Brilliant!' },
    { name: 'Anita Bose', role: 'Clothing Brand', text: 'ROAS went from 1.5x to 7x in 3 months. DMS completely transformed our Facebook strategy.' },
    { name: 'Sanjay Desai', role: 'Gym Owner', text: 'Filled all our gym memberships through Meta Ads. Best marketing investment we\'ve made.' },
  ],
  faq: [
    { q: 'What\'s the minimum budget for Meta Ads?', a: 'We recommend a minimum of ₹15,000/month in ad spend. Our management fees are separate.' },
    { q: 'Can you run ads on Instagram as well?', a: 'Yes! Meta Ads Manager manages both Facebook and Instagram ads from one platform.' },
    { q: 'How do you measure campaign success?', a: 'We track ROAS, CPL, CPA, reach, engagement, and conversions based on your specific business goals.' },
  ],
};

export default function MetaAds() {
  return <ServiceTemplate data={data} />;
}
